// extracted by mini-css-extract-plugin
export var notPlaying = "video-module--notPlaying--SSNvk";
export var videoWrap = "video-module--videoWrap--+k5Pa";
export var videoWrapDark = "video-module--videoWrapDark--7d4sQ";